import {SignalStoreDexieIDB} from '../dexie-db';
import * as signalStoreManagerConfig from './config.json';

async function loadAllSignalStoreIdbTables() {
	const dexieIDB = SignalStoreDexieIDB.getInstance();
	await dexieIDB.open();
	await dexieIDB.setEventListeners();
}

export class SignalStoreManagerService {
	private static instance: SignalStoreManagerService = null;
	/* ------------------------------------ - ----------------------------------- */
	public dexieIDB: SignalStoreDexieIDB = null;
	private indicators = {
		validated: false,
	};

	private constructor() {
		this.dexieIDB = SignalStoreDexieIDB.getInstance();
	}

	public static getInstance(): SignalStoreManagerService {
		if (!SignalStoreManagerService.instance) SignalStoreManagerService.instance = new SignalStoreManagerService();
		return SignalStoreManagerService.instance;
	}

	/**
	 * This method initializes the Signal Store Manager Service.
	 * It loads the DexieIDB instance, sets event listeners, and loads all signal store idb tables.
	 */
	public async loadAllSignalStoreIdbTables() {
		await this.dexieIDB.open();
		await this.dexieIDB.setEventListeners();
		await this.validateSyncableStores();
	}

	/**
	 * This Methods validates the syncable stores:
	 * clear / remove deprecates store / update / upgrade the syncable stores
	 */
	private async validateSyncableStores() {
		if (this.indicators.validated) return;
		// Delete deprecated stores from the db table:
		const deprecatedStores: string[] = signalStoreManagerConfig.deprecatedStores;
		await this.dexieIDB.signalsStoreTable?.bulkDelete(deprecatedStores);

		this.indicators.validated = true;
	}
}
